import React from 'react';
export function MiguelArquitectoLogo({
  size = 48
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0" data-id="element-245">
      {/* Background circle */}
      <circle cx="50" cy="50" r="50" fill="url(#gradientArquitecto)" data-id="element-246" />

      {/* Building/Architecture icon */}
      <rect x="35" y="40" width="12" height="25" fill="white" opacity="0.9" data-id="element-247" />
      <rect x="53" y="30" width="12" height="35" fill="white" opacity="0.9" data-id="element-248" />

      {/* Windows */}
      <rect x="37" y="43" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-249" />
      <rect x="42" y="43" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-250" />
      <rect x="37" y="50" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-251" />
      <rect x="42" y="50" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-252" />

      <rect x="55" y="33" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-253" />
      <rect x="60" y="33" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-254" />
      <rect x="55" y="40" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-255" />
      <rect x="60" y="40" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-256" />
      <rect x="55" y="47" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-257" />
      <rect x="60" y="47" width="3" height="4" fill="url(#gradientArquitecto)" data-id="element-258" />

      {/* Text "MT" */}
      <text x="50" y="85" fontSize="22" fontWeight="bold" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif" data-id="element-259">
        MT
      </text>

      {/* Gradient definition */}
      <defs data-id="element-260">
        <linearGradient id="gradientArquitecto" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-261">
          <stop offset="0%" stopColor="#F59E0B" data-id="element-262" />
          <stop offset="100%" stopColor="#D97706" data-id="element-263" />
        </linearGradient>
      </defs>
    </svg>;
}